<template>
  <v-container>
    <ClientServiceTerms isPage/>
  </v-container>
</template>

<script>
import ClientServiceTerms from "../../molecules/ClientServiceTerms"

export default {
  type: "page",
  name: "ClientServiceTermsPage",
  components: {
    ClientServiceTerms
  },
  data() {
    return {
      componentName: "ClientServiceTermsPage",
      data: {}
    };
  },
}
</script>
